import { gql } from '@apollo/client';

const SAQUE_FIELDS = `
    id
    entregadorId
    entregadorNome
    tipoPix
    chavePix
    dataSolicitacao
    valorSolicitado
    taxaAntecipacao
    taxaTipo
    taxaValorConfigurado
    valorGarantido
    valorLiquido
    qtdeColetas
    status
    statusDescricao
    asaasTransferId
    envioSemConfirmacao
    dataPagamento
    comprovanteUrl
    motivoFalha
    motivoReprovacao
`;

export const GRAPHQL_BUSCAR_SAQUES = gql`
    query BuscarSaques($filter: SaqueFilter) {
        saques(filter: $filter) {
            data {
                ${SAQUE_FIELDS}
            }
            total
            hasNextPage
        }
    }
`;

export const GRAPHQL_RELATORIO_SAQUE_TAXAS = gql`
    query RelatorioSaqueTaxas($dataInicial: String!, $dataFinal: String!) {
        relatorioSaqueTaxas(dataInicial: $dataInicial, dataFinal: $dataFinal) {
            qtdeSaques
            totalSolicitado
            totalTaxas
            totalLiquido
            dias {
                data
                qtdeSaques
                totalSolicitado
                totalTaxas
                totalLiquido
            }
        }
    }
`;

export const GRAPHQL_RELATORIO_SAQUES = gql`
    query RelatorioSaques($dataInicial: String!, $dataFinal: String!) {
        relatorioSaques(dataInicial: $dataInicial, dataFinal: $dataFinal) {
            id
            entregadorNome
            tipoPix
            chavePix
            dataSolicitacao
            taxaAntecipacao
            valorGarantido
            valorLiquido
            qtdeColetas
            status
            statusDescricao
            dataPagamento
            valorTotalFrete
            valorTotalTaxaRetorno
            tipoPessoa
            cpfCnpj
            endLogradouro
            endNumero
            endComplemento
            endBairro
            endCEP
            dadosAtualizado
        }
    }
`;

export const GRAPHQL_APROVAR_SAQUE = gql`
    mutation AprovarSaque($id: ID!) {
        aprovarSaque(id: $id) {
            ${SAQUE_FIELDS}
        }
    }
`;

export const GRAPHQL_REPROVAR_SAQUE = gql`
    mutation ReprovarSaque($id: ID!, $motivo: String!) {
        reprovarSaque(id: $id, motivo: $motivo) {
            ${SAQUE_FIELDS}
        }
    }
`;

export const GRAPHQL_REPROCESSAR_SAQUE = gql`
    mutation ReprocessarSaque($id: ID!, $forcar: Boolean) {
        reprocessarSaque(id: $id, forcar: $forcar) {
            ${SAQUE_FIELDS}
        }
    }
`;

export const GRAPHQL_SINCRONIZAR_SAQUE = gql`
    mutation SincronizarSaque($id: ID!) {
        sincronizarSaque(id: $id) {
            ${SAQUE_FIELDS}
        }
    }
`;

export const GRAPHQL_SAQUE_ITENS = gql`
    query SaqueItens($id: ID!) {
        saqueItens(id: $id) {
            tipo
            chave
            coletaId
            numeroInterno
            unidadeNomeFantasia
            data
            dataHora
            periodoNome
            periodoHoraInicio
            periodoHoraFim
            valor
        }
    }
`;
